module.exports = __webpack_public_path__ + "static/media/trifold.0c99c02b.jpg";